import { render, staticRenderFns } from "./BatteryFile.vue?vue&type=template&id=ce8ae7b4&scoped=true&"
import script from "./BatteryFile.vue?vue&type=script&lang=js&"
export * from "./BatteryFile.vue?vue&type=script&lang=js&"
import style0 from "./BatteryFile.vue?vue&type=style&index=0&id=ce8ae7b4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce8ae7b4",
  null
  
)

export default component.exports